import cardSlides from './cardSlides';

const xlSlides = cardSlides;

export default xlSlides;
